import { TOfferCalculatorState } from '../types/redux';

export const selectDefaultFormState = (state: TOfferCalculatorState) => {
  return state.calculator.defaultFormState;
};
